import OverPassRegular from '../assets/fonts/Overpass-Regular.ttf'
import OverPassBold from '../assets/fonts/Overpass-Bold.ttf'
// import OverPassSemiBold from '../assets/fonts/Overpass-SemiBold.ttf'
// import OverPassThin from '../assets/fonts/Overpass-Thin.ttf'
// import OverPassLight from '../assets/fonts/Overpass-Light.ttf'
import {createMuiTheme} from '@material-ui/core/styles'


const overpass = {
  fontFamily: 'Overpass',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Overpass'),
    local('Overpass-Regular'),
    url(${OverPassRegular}) format('ttf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

const overpassBold = {
  fontFamily: 'Overpass',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 600,
  src: `
    local('Overpass'),
    local('Overpass-Bold'),
    url(${OverPassBold}) format('ttf')
  `,
  unicodeRange:
    'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
}

let theme = createMuiTheme({
  typography: {
    fontFamily: 'Overpass, Arial',
  },
  palette: {
    type: 'dark',
    primary: {
      light: '#66b1cc',
      main: '#3497bb',
      dark: '#27718c',
    },
    background: {
      default: '#000000'
    },
  },
  shape: {
    borderRadius: 4,
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    toolbar: {
      minHeight: 48,
    },
  },
})

export default {
  ...theme,
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [overpass, overpassBold],
      },
      background: 'linear-gradient(45deg, rgba(0,0,0,1) 0%, rgba(32,29,29,1) 100%)',
    },
    MuiDrawer: {
      paper: {
        backgroundColor: '#18202c',
      },
    },
    MuiButton: {
      root: {
        fontWeight: 600,
        fontSize: 12,
        borderRadius: 2,
        padding: '15px 20px'
      },
      text: {
        padding: '15px 20px'
      },
      default: {
        padding: '15px 20px'
      },
      contained: {
        boxShadow: 'none',
        '&:active': {
          boxShadow: 'none',
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: 'none',
        margin: '0 16px',
        minWidth: 0,
        padding: 0,
        [theme.breakpoints.up('md')]: {
          padding: 0,
          minWidth: 0,
        },
      },
    },
    MuiFormControlLabel: {
      root: {
        color: 'rgba(255, 255, 255, .75)'
      }
    },
    MuiInputLabel: {
      root: {
        fontSize: 16
      }
    },
    MuiInput: {
      root: {
        fontSize: 20
      }
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: '#404854',
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: 'inherit',
        marginRight: 0,
        '& svg': {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
    MuiMobileStepper: {
      root: {
        padding: '0',
        backgroundColor: 'transparent'
      },
      progress: {
        width: '100%',
        backgroundColor: 'rgba(255, 255, 255, .5)',
        '&.MuiLinearProgress-bar': {
          backgroundColor: 'rgba(255, 255, 255, 1)',
        },
      }
    },
    MuiStep: {
      completed: {
        color: '#1ccd7e'
      }
    },
    MuiStepIcon: {
      active: {
        color: '#fff !important'
      },
      completed: {
        color: '#1ccd7e !important'
      }
    }
  },
}
